import { NgModule, ErrorHandler } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { RouterModule } from '@angular/router';

import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';

import { SharedModule } from '../shared/shared.module';
import { PageNotFoundViewComponent } from './components/page-not-found-view/page-not-found-view.component';
import { ConnectionErrorViewComponent } from './components/connection-error-view/connection-error-view.component';
import { GeneralErrorViewComponent } from './components/general-error-view/general-error-view.component';
import { LayoutComponent } from './components/layout/layout.component';
import { FooterComponent } from './components/footer/footer.component';
import { AuthInterceptor } from './interceptors/auth.interceptor';
import { HttpErrorInterceptor } from './interceptors/http-error.interceptor';
import { GlobalErrorHandler } from './services/global-error-handler.service';
import { coreReducer } from './store';
import { SnackbarEffects } from './store/snackbar/snackbar.effects';
import { UIEffects } from './store/ui/ui.effects';
import { LoadingEffects } from './store/loading/loading.effects';
import { LoadingComponent } from './components/loading/loading.component';
import { EntityTypesEffects } from './store/entity-types/entity-types.effects';
import { MeasurementUnitsEffects } from './store/measurement-units/measurement-units.effects';
import { NumericPropertyDisplayComponent } from './components/entity/property/numeric-property-display/numeric-property-display.component';

const components = [
  FooterComponent,
  LayoutComponent,
  PageNotFoundViewComponent,
  ConnectionErrorViewComponent,
  GeneralErrorViewComponent,
  LoadingComponent
];

@NgModule({
  declarations: [...components, NumericPropertyDisplayComponent],
  imports: [
    CommonModule,
    RouterModule,
    SharedModule,
    StoreModule.forFeature('core', coreReducer),
    EffectsModule.forFeature([SnackbarEffects, LoadingEffects, UIEffects, EntityTypesEffects, MeasurementUnitsEffects])
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: HttpErrorInterceptor, multi: true },
    { provide: ErrorHandler, useClass: GlobalErrorHandler }
  ],
  exports: [...components, NumericPropertyDisplayComponent]
})
export class CoreModule {}
